import { Hourglass, Settings, Sigma } from "lucide-react";
import ChartColIcon from "./IconComponent/ChartColIcon";
import DefinitionLetterIcon from "./IconComponent/DefinitionLetterIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_MIDDLE_TOOLTIPS } from "../constants/menuTooltips";

export default function MenuMiddle({
  mode,
  activeFilter,
  activeAction = "stats",
  onActionChange = () => {},
  settingsActive = false,
  onSettingsClick = () => {},
}) {
  if (mode !== "register") return <div className="menuMilieuContainer" />;

  const isLastGameFilter = activeFilter === "lastGame";

  const settingsIcon = (
    <MenuIconTooltip
      tooltip={MENU_MIDDLE_TOOLTIPS.settings}
      placement="left"
      portal
    >
      <Settings
        size={50}
        color={settingsActive ? "#39210d" : "#b8a99a"}
        strokeWidth={1}
        onClick={onSettingsClick}
        style={{
          opacity: settingsActive ? 1 : 0.3,
          cursor: "pointer",
        }}
        aria-label="Paramètres du registre"
      />
    </MenuIconTooltip>
  );

  return (
    <div className="menuMilieuContainer">
      <MenuIconTooltip
        tooltip={MENU_MIDDLE_TOOLTIPS.stats}
        placement="left"
        portal
      >
        <ChartColIcon
          size={50}
          color={activeAction === "stats" ? "#39210d" : "#b8a99a"}
          strokeWidth={1}
          onClick={() => onActionChange("stats")}
          style={{ opacity: activeAction === "stats" ? 1 : 0.3 }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_MIDDLE_TOOLTIPS.edit}
        placement="left"
        portal
      >
        <DefinitionLetterIcon
          size={50}
          color={activeAction === "edit" ? "#39210d" : "#b8a99a"}
          onClick={() => onActionChange("edit")}
          style={{
            opacity: activeAction === "edit" ? 1 : 0.3,
            cursor: "pointer",
          }}
          aria-label={MENU_MIDDLE_TOOLTIPS.edit}
        />
      </MenuIconTooltip>

      {isLastGameFilter ? (
        <MenuIconTooltip
          tooltip={MENU_MIDDLE_TOOLTIPS.lastGameSummary}
          placement="left"
          portal
        >
          <Sigma
            size={50}
            color={activeAction === "lastGameSummary" ? "#39210d" : "#b8a99a"}
            strokeWidth={1}
            onClick={() => onActionChange("lastGameSummary")}
            style={{
              opacity: activeAction === "lastGameSummary" ? 1 : 0.3,
              cursor: "pointer",
            }}
            aria-label="Synthèse de la dernière partie"
          />
        </MenuIconTooltip>
      ) : (
        <MenuIconTooltip
          tooltip={MENU_MIDDLE_TOOLTIPS.filteredStats}
          placement="left"
          portal
        >
          <Sigma
            size={50}
            color={activeAction === "filteredStats" ? "#39210d" : "#b8a99a"}
            strokeWidth={1}
            onClick={() => onActionChange("filteredStats")}
            style={{
              opacity: activeAction === "filteredStats" ? 1 : 0.3,
              cursor: "pointer",
            }}
            aria-label="Statistiques des données filtrées"
          />
        </MenuIconTooltip>
      )}

      <MenuIconTooltip
        tooltip={MENU_MIDDLE_TOOLTIPS.recency}
        placement="left"
        portal
      >
        <Hourglass
          size={50}
          color={activeAction === "recency" ? "#39210d" : "#b8a99a"}
          strokeWidth={1}
          onClick={() => onActionChange("recency")}
          style={{
            opacity: activeAction === "recency" ? 1 : 0.3,
            cursor: "pointer",
          }}
          aria-label="Récence des mots"
        />
      </MenuIconTooltip>

      {settingsIcon}
    </div>
  );
}
